import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ScriptInjectionService {
    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    public injectScripts() {
        // Always add SHA-256 hash to CSP config on server side
        // this.injectGTMScript(environment.google.tagManager.containerId);
        // this.injectGTMNoScript(environment.google.tagManager.containerId);
    }
    
    injectGTMScript(gtmId: string): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        // GTM Script
        const gtmScript = document.createElement('script');
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        document.head.appendChild(gtmScript);

        // GTM Data Layer
        const dataLayerScript = document.createElement('script');
        dataLayerScript.id = 'gtm-data-layer';
        //Adding line breaks for has consistency with server-side CSP
        dataLayerScript.innerHTML = 
        "window.dataLayer = window.dataLayer || [];\n" +
        "function gtag(){dataLayer.push(arguments);}\n" +
        "gtag('js', new Date());\n" +
        `gtag('config', '${gtmId}');`;
        document.head.appendChild(dataLayerScript);
    }

    injectGTMNoScript(gtmId: string): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
    }

    // injectGoogleAnalyticsScript(trackingId: string): void {
    //     if (!isPlatformBrowser(this.platformId)) {
    //         return;
    //     }

    //     const gaScript = document.createElement('script');
    //     gaScript.async = true;
    //     gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    //     document.head.appendChild(gaScript);

    //     const gaInitScript = document.createElement('script');
    //     gaInitScript.innerHTML = `
    //         window.dataLayer = window.dataLayer || [];
    //         function gtag(){dataLayer.push(arguments);}
    //         gtag('js', new Date());
    //         gtag('config', '${trackingId}');
    //     `;
    //     document.head.appendChild(gaInitScript);
    // }
}